<template>
  <div>
    <ProducaoBar
      :is-midias-moderacao="false"
      :cod_pasta="cod_pasta"
      :selected-tab-number="4"
    />
    <v-row class="ma-0 pa-5">
      <v-col>
        <CronometrosRecebidos
          v-if="cod_producao && cronometrosProducao"
          :data="cronometrosProducao"
          :cod_producao="cod_producao"
          :current-cronometros-page="page"
          :changePasta="changePasta"
        />
        <v-pagination
          v-if="cronometrosProducao"
          class="mt-5"
          v-model="page"
          :length="cronometrosProducao.totalPages || 1"
          @input="handleAprovadasPageChange"
          :total-visible="paginasExibidas"
        />
      </v-col>
      <v-col>
        <CronometroEmExibicao
          v-if="cod_producao && cronometroEmExibicao"
          :cronometro-em-exibicao="cronometroEmExibicao"
          :cod_producao="cod_producao"
          :aprovadas_current_page="page"
          :page-moderada="pageModerada"
        />
        <v-pagination
          v-if="cronometroEmExibicao"
          class="mt-5"
          v-model="pageModerada"
          :length="1"
          @input="handleModeradasPageChange"
          :total-visible="paginasExibidas"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import ProducaoBar from "../components/Producao/ProducaoBar.vue";
import CronometrosRecebidos from "@/components/Cronometro/CronometrosRecebidos.vue";
import CronometroEmExibicao from "@/components/Cronometro/CronometroEmExibicao.vue";

export default {
  name: "EnquetesView",
  components: {
    ProducaoBar,
    CronometrosRecebidos,
    CronometroEmExibicao,
  },
  data() {
    return {
      isDark: this.$vuetify.theme.dark,
      cod_producao: null,
      page: 1,
      pageModerada: 1,
      size: 5,
      paginasExibidas: 9,
      timerAprovada: null,
      timerModerada: null,
      cod_pasta: null,
    };
  },
  beforeCreate() {
    this.$vuetify.theme.themes.dark = this.$vuetify.theme.framework.theme.defaults.dark;
    this.$vuetify.theme.themes.light = this.$vuetify.theme.framework.theme.defaults.light;
  },
  async created() {
    const selectedProducao = this.$store.state.producoes.selectedProducao;
    if (selectedProducao?.cod_producao) {
      this.cod_producao = selectedProducao.cod_producao;
    }
    if (this.cod_producao) {
      await Promise.all([
        this.getPastas({ cod_producao: this.cod_producao }),
        this.getCronometrosProducao({
          cod_producao: this.cod_producao,
          flg_favorita: this.$store.state.cronometros.flg_favorita ?? false,
          filtro_texto: this.$store.state.cronometros.filtroCronometros,
          cod_pasta: this.cod_pasta,
          size: this.size,
          page: this.page,
        }),
        this.getCronometroEmExibicao({
          cod_producao: this.cod_producao,
        }),
      ]);
      this.updateTimers();
    }
  },
  methods: {
    ...mapActions({
      getProducoes: "producoes/getProducoes",
      getPastas: "pastas/getPastas",
      getCronometrosProducao: "cronometros/getCronometrosByProducao",
      getCronometroEmExibicao: "cronometros/getCronometroEmExibicao",
      setFlgFavorita: "cronometros/setFlgFavorita",
    }),
    changeTheme(e) {
      localStorage.setItem("@socialcam/is_dark_theme", e);
      this.$vuetify.theme.dark = e;
    },
    async changePasta(cod_pasta) {
      this.cod_pasta = cod_pasta;
      this.updateTimers();
    },
    async handleAprovadasPageChange() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    async handleModeradasPageChange() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },

    updateTimers() {
      clearInterval(this.timerAprovada);
      clearInterval(this.timerModerada);

      this.timerAprovada = setInterval(async () => {
        //get cronometros here
        await this.getCronometrosProducao({
          cod_producao: this.$store.state.producoes.selectedProducao.cod_producao,
          flg_favorita: this.$store.state.cronometros.flg_favorita,
          filtro_texto: this.$store.state.cronometros.filtroCronometros,
          cod_pasta: this.cod_pasta,
          size: this.size,
          page: this.$store.state.cronometros.cronometrosProducao
            ? this.$store.state.cronometros.cronometrosProducao.currentPage
            : this.page,
        });
      }, 60000); // Chama a função a cada 1 minuto.

      this.timerModerada = setInterval(async () => {
        await this.getCronometroEmExibicao({
          cod_producao: this.$store.state.producoes.selectedProducao.cod_producao,
        });
      }, 60000); // Chama a função a cada 1 minuto.
    },
  },
  computed: {
    ...mapGetters({
      dark_theme: "themes/getTheme",
      cronometrosProducao: "cronometros/getterCronometrosProducao",
      cronometroEmExibicao: "cronometros/getterCronometroEmExibicao",
      filtroCronometros: "cronometros/getterFiltroCronometros",
    }),
  },
  beforeDestroy() {
    clearInterval(this.timerAprovada);
    clearInterval(this.timerModerada);
  },
  watch: {
    "$store.state.producoes.selectedProducao": async function (newValue) {
      this.cod_producao = newValue.cod_producao;
      await this.getPastas({ cod_producao: this.cod_producao });

      await this.getCronometroEmExibicao({
        cod_producao: this.$store.state.producoes.selectedProducao.cod_producao,
      });

      await this.getCronometrosProducao({
        cod_producao: this.$store.state.producoes.selectedProducao.cod_producao,
        flg_favorita: this.$store.state.cronometros.flg_favorita ?? false,
        filtro_texto: this.filtroCronometros,
        cod_pasta: this.cod_pasta,
        size: this.size,
        page: this.$store.state.cronometros.cronometrosProducao
          ? this.$store.state.cronometros.cronometrosProducao.currentPage
          : this.page,
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
